import styles from './styles.module.scss'

export const PageLoader = () => {
  return (
    <div className={styles.container}>
      <div className={styles.loader} />
    </div>
  )
}
